export default function (urlToTable) {
    let request = new XMLHttpRequest();
    let parsedTables = {};

    request.onload = getData;
    request.open("GET", urlToTable, false);
    request.send();

    function getData() {
        let parser = new DOMParser();
        let doc = parser.parseFromString(request.responseText, "text/html");

        parsedTables = parseTables(doc);
    }

    function parseTables(doc) {
        let tables = Array.from(doc.getElementById('sheets-viewport').querySelectorAll('div > table > tbody'));
        let cities = getCities(doc);
        let allCitiesData = {};

        for (let i = 0; i < tables.length; i++) {
            let singleCityCandidates = []

            Array.from(tables[i].querySelectorAll('tr > th')).forEach(element => element.remove());

            singleCityCandidates = getCityCandidatesFromTable(tables[i]);
            sortTable(singleCityCandidates);

            allCitiesData[cities[i]] = singleCityCandidates;
        }

        return allCitiesData;
    }

    function getCities(doc) {
        let elements = doc.querySelectorAll('#sheet-menu > li > a');
        let cities = [];

        for (let i = 0; i < elements.length; i++) {
            cities[i] = elements.item(i).innerText;
        }

        return cities;
    }

    function getCityCandidatesFromTable(table) {
        let mayors = [], regionConsignment = [], cityConsignment = [], cityCandidates = [];
        for (let i = 1; i < table.childElementCount; i++) {
            let mayorCandidate = [];
            let regionConsignmentCandidate = [];
            let cityConsignmentCandidate = [];
            for (let j = 0; j < 6; j++) {
                let candidateField = table.getElementsByTagName('tr')[i].getElementsByTagName('td').item(j);

                if (candidateField === null) {
                    return;
                }

                if (j < 2) {
                    mayorCandidate.push(candidateField.innerText);
                } else if (j < 4) {
                    regionConsignmentCandidate.push(candidateField.innerText);
                } else {
                    cityConsignmentCandidate.push(candidateField.innerText);

                    if (j === 5) {
                        mayors.push(mayorCandidate);
                        regionConsignment.push(regionConsignmentCandidate);
                        cityConsignment.push(cityConsignmentCandidate);
                    }
                }
            }
            if (i === table.childElementCount - 1) {
                cityCandidates[0] = mayors;
                cityCandidates[1] = regionConsignment;
                cityCandidates[2] = cityConsignment;
            }
        }

        return cityCandidates;
    }

    function sortTable(table) {
        for (let i = 0; i < table.length; i++) {
            let city = table[i];

            for (let j = 0; j < city.length - 1; j++) {
                for (let k = 0; k < city.length - j - 1; k++) {
                    if (parseInt(city[k][1], 10) < parseInt(city[k+1][1], 10)) {
                        let tmp = city[k];
                        city[k] = city[k + 1];
                        city[k + 1] = tmp;
                    }
                }
            }
        }
    }

    return parsedTables;
}